/*
 * @Author: Christion.Young
 * @Date: 2025-09-08 16:00:00
 * @LastEditors: Christion.Young
 * @LastEditTime: 2025-09-08 16:00:00
 * @Description: 数据字典配置 - 统一管理各种选项配置
 */

// 接单类型
export const ORDER_TYPE_OPTIONS = [
  { value: "1", label: "单一接单" },
  { value: "2", label: "同时多单" },
];

// 服务时长
export const INTERVAL_TIME_OPTIONS = [
  { value: "1", label: "60分钟" },
  { value: "2", label: "120分钟" },
  { value: "3", label: "180分钟" },
  { value: "4", label: "一天" },
  { value: "5", label: "一次/项" },
];

// 服务方式
export const SERVICE_WAY_OPTIONS = [
  { value: 1, label: "到店服务" },
  { value: 2, label: "上门服务" },
  { value: 3, label: "线上服务" },
];

// 性别
export const SEX_OPTIONS = [
  { value: "1", label: "男" },
  { value: "2", label: "女" },
];

// 员工类型
export const STAFF_TYPE_OPTIONS = [
  { value: 1, label: "高级" },
  { value: 2, label: "中级" },
  { value: 3, label: "初级" },
  { value: 4, label: "全职" },
  { value: 5, label: "兼职" },
];

// 商户类型
export const MERCHANT_TYPE_OPTIONS = [
  { value: "0", label: "法人或个体工商户" },
  { value: "1", label: "自然人" },
];

// 获取字典标签的通用方法
export function getDictionaryLabel(options, value, defaultLabel = "未知") {
  const option = options.find((opt) => opt.value == value);
  return option ? option.label : defaultLabel;
}

// 导出所有字典配置
export default {
  ORDER_TYPE_OPTIONS,
  INTERVAL_TIME_OPTIONS,
  SERVICE_WAY_OPTIONS,
  SEX_OPTIONS,
  STAFF_TYPE_OPTIONS,
  MERCHANT_TYPE_OPTIONS,
  getDictionaryLabel,
};
